import OrderState from '~/constants/home/orderState';
import { useGetUserPurchase } from '~/context/home/UserPurchaseContext';

export default function useHasPurchaseInProgress() {
  const {
    data: { orderState }
  } = useGetUserPurchase();

  return (
    orderState === OrderState.InProgress ||
    orderState === OrderState.InProgressWithTradeIn
  );
}
